import { DictionarySewerTypeAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionarySewerTypes() {
  return useAutocompleteSource<DictionarySewerTypeAutocomplete>({
    url: EvidenceAPI.DICTIONARY_SEWER_TYPES + '/autocomplete',
  });
}
